import { countryKeyFromOrg, countryProfile, type CountryKey } from "@/lib/countryProfile";

let activeCurrency: string | null = null;
let activeCountry: CountryKey | null = null;
let activeTimeZone: string | null = null;

export function setActiveOrgFormat(input: {
  currency: string | null;
  countryKey: CountryKey | null;
  timeZone: string | null;
}): void {
  activeCurrency = input.currency;
  activeCountry = input.countryKey;
  activeTimeZone = input.timeZone?.trim() ? input.timeZone.trim() : null;
}

export function resolveOrgTimeZone(
  org: { timeZone?: string | null; countryKey?: string | null } | null | undefined,
): string {
  const trimmed = org?.timeZone?.trim();
  if (trimmed) return trimmed;
  return countryProfile(countryKeyFromOrg(org ?? null)).timeZone;
}

export function activeOrgCurrencyCode(language: string): string {
  if (activeCurrency) return activeCurrency;
  return language === "pt-BR" ? "BRL" : "USD";
}

export function activeOrgCountryKey(): CountryKey {
  return activeCountry ?? "BR";
}

export function activeOrgTimeZone(): string {
  return resolveOrgTimeZone({
    timeZone: activeTimeZone,
    countryKey: activeCountry,
  });
}
